// Exotics widgets share PricingProvider (architect E8). Thin pass-through.
import type { FC } from 'react';

import ExoticsRiskLadderModalWidget from './exotics-risk-ladder-modal-widget';

const ExoticsRiskLadderModalWrapperProvider: FC = () => <ExoticsRiskLadderModalWidget />;

export default ExoticsRiskLadderModalWrapperProvider;
